import ForgetPassword from "../../../../jsx/pages/Agent/ForgotPassword";

const LoginWrapper = function (props) {
  return <ForgetPassword />;
};

export default constore(LoginWrapper);
